export function ElearningSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/elearning.svg'"></ng-include>`
    }
}